import { highlightCodeBlocks } from './_wiki';

highlightCodeBlocks('pre > code');
